<div class="btn text-15 font-sans text-white py-10 rounded-2xl border-5 border-lightgray bg-medgray" style="border-style: outset;"><slot></slot></div>